import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import dayjs from 'dayjs';

import { api } from '@/api';
import { DEFAULT_DATE_FORMAT, ERRORS_CODE, RAW_DATE_FORMAT } from '@/common/constants';
import { API_URL } from '@/dtos';

import {
  ContributionFrequency,
  ContributionStatus,
  EnrollmentContributionDetails,
} from '../EnrollmentDetailsContributions.types';

const useGetEmployeeContributionInfoQuery = (employeeId: string) => {
  const { data, isLoading, error } = useQuery(
    [API_URL.RECURRING_CONTRIBUTIONS],
    () =>
      api.get(API_URL.RECURRING_CONTRIBUTIONS, {
        params: {
          employee_id: employeeId,
        },
      }),
    {
      retry: 0,
    }
  );

  const formattedData = useMemo<EnrollmentContributionDetails>((): EnrollmentContributionDetails => {
    const currentData = data?.data;

    const formattedStartDate = currentData?.start_date
      ? dayjs(currentData?.start_date, RAW_DATE_FORMAT).format(DEFAULT_DATE_FORMAT)
      : '';
    const formattedEndDate = currentData?.end_date
      ? dayjs(currentData?.end_date, RAW_DATE_FORMAT).format(DEFAULT_DATE_FORMAT)
      : '';
    return {
      id: currentData?.id || 0,
      amount: currentData?.amount || 0,
      frequency: currentData?.frequency_type as ContributionFrequency,
      recurringDay: currentData?.recurring_day_number || 0,
      dateRange: formattedStartDate ? `${formattedStartDate} - ${formattedEndDate || 'Forever'}` : '',

      status: currentData?.status as ContributionStatus,
      nextScheduledDate: currentData?.next_scheduled_date
        ? dayjs(currentData?.next_scheduled_date, RAW_DATE_FORMAT).format(DEFAULT_DATE_FORMAT)
        : '',
      notificationDate: (currentData?.notification_date as unknown as string) || '',
    };
  }, [data?.data]);

  const isNotFound = useMemo(() => {
    // @ts-ignore
    return error?.status === ERRORS_CODE.NOT_FOUND;
  }, [error]);

  return {
    isNotFound,
    data: formattedData,
    isLoading,
  };
};

export default useGetEmployeeContributionInfoQuery;
